<template>
  <footer>
    <div v-if="screenWidth > 767" class="footer-pc">
      <div class="container-md">
        <div class="row jc-between">
          <div class="left col-8">
            <ul class="nav row">
              <li
                class="col-4"
                v-for="(nav, index) in menusList"
                :key="index"
                :class="{ 'no-margin': index == menusList.length - 1 }"
              >
                <span class="title">{{ nav.name }}</span>

                <ul class="subNav">
                  <li
                    v-for="(item, index) in nav.children"
                    :key="`${item.path}/${index}`"
                    @click="goListPage(nav, item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="right col-4">
            <div
              v-for="(item, index) in concatListPc"
              :key="index"
              class="concat-item"
              :class="`concat-item${index + 1}`"
            >
              <img :src="item.icon" alt="" :class="`img-mb-icon${index}`" />
              <div class="tel-info">
                <div>{{ item.info }}</div>
                <div class="tel" v-if="item.tel">{{ item.tel }}</div>
                <div v-else class="wechat">
                  <img
                    v-if="item.children[qcode_img_index]"
                    :src="item.children[qcode_img_index].qcode_img"
                    alt=""
                    class="qcode_img"
                    :style="{
                      left:
                        qcode_img_index == 1
                          ? '52%'
                          : qcode_img_index == 2
                          ? '90%'
                          : '13%',
                    }"
                  />

                  <div
                    v-for="(el, indexes) in item.children"
                    :key="indexes"
                    :class="`chat-item${indexes + 1}`"
                    class="chat-item"
                  >
                    <img
                      :src="el.showQd ? el.hover_img : el.icon"
                      alt=""
                      @mouseenter="
                        el.showQd = true;
                        qcode_img_index = indexes;
                      "
                      @mouseleave="
                        el.showQd = false;
                        qcode_img_index = null;
                      "
                      @click="goLink(indexes)"
                    />
                    <div class="chat-name">{{ el.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-mb" v-else>
      <div
        v-for="(item, index) in concatListPc"
        :key="index"
        class="mb-concat-item"
        :class="`concat-item${index + 1}`"
      >
        <img :src="item.icon" alt="" :class="`img-mb-icon${index}`" />
        <div class="tel-info">
          <div>{{ item.info }}</div>
          <div class="tel" v-if="item.tel">{{ item.tel }}</div>
          <div v-else class="wechat">
            <div
              v-for="(el, indexes) in item.children"
              :key="indexes"
              :class="`chat-item${indexes + 1}`"
              @click="goLink(indexes)"
            >
              <img :src="el.icon" alt="" />
              <div class="chat-name">{{ el.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      版权所有：深圳安道云科股份有限公司
      <a
        href="https://beian.miit.gov.cn/"
        style="color: #d0d0d0"
        target="_blank"
        >{{ AQUrl }}</a
      >
      网站地图
    </div>
  </footer>
</template>
<script>
export default {
  props: ["screenWidth"],
  data() {
    return {
      qcode_img_index: null,
      concatListPc: [
        {
          icon: require("@/assets/images/image-v2.0.0/fangkeliuyan.png"),
          active: require("@/assets/images/image-v2.0.0/wei-3.png"),
          info: "全国客户服务热线 7*24小时",
          tel: "400-632-8880",
        },
        // {
        //   icon: require("@/assets/images/image-v2.0.0/phone.png"),
        //   info: "商务专属热线 7*24小时",
        //   tel: "18575170330",
        //   active: require("@/assets/images/image-v2.0.0/wei-3.png"),
        // },
        {
          icon: require("@/assets/images/image-v2.0.0/attention.png"),
          info: "关注AMDOX",
          children: [
            {
              name: "官方公众号",
              icon: require("@/assets/images/image-v2.0.0/wei-1.png"),
              showQd: false,
              qcode_img: require("@/assets/images/image-v2.0.0/admox-QR.png"),
              hover_img: require("@/assets/images/image-v2.0.0/wei-3.png"),
            },
            {
              name: "官方服务号",
              icon: require("@/assets/images/image-v2.0.0/wei-2.png"),
              showQd: false,
              qcode_img: require("@/assets/images/image-v2.0.0/wxkf1.png"),
              hover_img: require("@/assets/images/image-v2.0.0/wei-4.png"),
            },
            {
              name: "在线商城",
              icon: require("@/assets/images/image-v2.0.0/JD.png"),
              showQd: false,
              qcode_img: require("@/assets/images/image-v2.0.0/JD-QR.png"),
              hover_img: require("@/assets/images/image-v2.0.0/JD-2.png"),
            },
          ],
        },
      ],
      AQUrl: "",
      menusList: [],
    };
  },
  created() {
    this.getList();
    this.AQUrl = "粤ICP备16017081号";
  },
  methods: {
    goListPage(nav1, jk) {
      let path = `${nav1.path}?type=${nav1.flag}&${
        nav1.productCategoryId
          ? "id=" + nav1.productCategoryId
          : nav1.productModuleId
          ? "id=" + nav1.productModuleId
          : nav1.newsCategoryId
          ? "id=" + nav1.newsCategoryId
          : ""
      }`;
      if (jk) {
        path = path + `&path=${jk.name}`;
      }
      // console.log(path,'path====')
      this.$store.dispatch("saveTabInStore", nav1);
      // return path;
      this.$router.push(path);
    },
    async getList() {
      let list = await this.$store.dispatch("getProductNavList");
      this.menusList = list;
    },
    goServe() {
      window.open("https://url.cn/D1LRxZe2?_type=wpa&qidian=true", "_blank");
    },
    goLink(index) {
      if (index == 2) {
        window.open("https://mall.jd.com/index-11466759.html", "_blank");
      } else if (index == 0) {
        window.open(
          "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU0MDg3MTAzNA==&scene=110#wechat_redirect​",
          "_blank"
        );
      } else if (index == 1)
        window.open(
          "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0MTQyMDk5Nw==&scene=110#wechat_redirect​",
          "_blank"
        );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./sass/layout-pc.scss";
@import "./sass/layout-mb.scss";
@media (max-width: 465px) {
  .serve {
    flex-direction: column;
    text-align: center;

    .online {
      margin-top: 5rem / $rem;
      margin-left: 0;
    }
  }
}

.bottom {
  height: 34px;
  line-height: 34px;
  background-color: #444444;
  color: #b5b5b5;
  font-size: 7px;
  text-align: center;
  border-top: 1rem / $rem solid #707070;
}
</style>
